// frontend-web/src/api.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { getDeviceId } from "./utils/deviceId";


/*
----------------------------------
ENV CONFIG
----------------------------------
Local:
REACT_APP_API_URL=http://127.0.0.1:5001/api

Staging:
REACT_APP_API_URL=https://apistaging.eduat10.com/api
----------------------------------
*/

//const BASE_URL =
  //process.env.REACT_APP_API_URL ||
  //"https://apistaging.eduat10.com/api";
const BASE_URL = "https://api.eduat10.com/api";  

console.log("AXIOS BASE URL >>>", BASE_URL);

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  withCredentials: true, // 🔥 FIX #1
});

// ---------------- REQUEST ----------------
api.interceptors.request.use(
  (config) => {
    // 🔐 JWT TOKEN
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 🔥 DEVICE ID (SYNC & SAFE)
    const deviceId = getDeviceId();
    if (deviceId) {
      config.headers["X-DEVICE-ID"] = deviceId;
    }

    // 📦 CONTENT TYPE
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ---------------- RESPONSE ----------------
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      window.location.replace("/login");
    }

    return Promise.reject(error);
  }
);

// -------- AUTH --------
export const getCurrentUser = () => {
  const token = localStorage.getItem("token");
  return token ? jwtDecode(token) : null;
};

// ----------------------------------------------------
// USERS APIs
// ----------------------------------------------------
export const getUserDetails = (id) =>
  api.get(`/admin/users/${id}`);

// ----------------------------------------------------
// QUESTIONS APIs
// ----------------------------------------------------
export const fetchQuestionById = (id) =>
  api.get(`/admin/questions/${id}`);

export const updateQuestion = (id, payload) =>
  api.put(`/admin/questions/${id}`, payload);

export const deleteQuestionById = (id) =>
  api.delete(`/admin/questions/${id}`);

export const fetchQuestionsList = (classId, subjectId) =>
  api.get(
    `/admin/questions?class_id=${classId}&subject_id=${subjectId}`
  );

// ----------------------------------------------------
// CSV UPLOAD
// ----------------------------------------------------
export const uploadQuestionsCSV = (formData) =>
  api.post(`/admin/questions/upload_csv`, formData);

// ----------------------------------------------------
// PRACTICE SET APIs
// ----------------------------------------------------
export const createPracticeSet = (payload) =>
  api.post(`/admin/practice_set`, payload);

export const fetchAllPracticeSets = () =>
  api.get(`/admin/practice_set/list`);

export const assignQuestionsToPracticeSet = (
  practiceSetId,
  questionIds
) =>
  api.post(
    `/admin/practice_set/${practiceSetId}/assign_questions`,
    { question_ids: questionIds }
  );

export const generateRandomQuestions = (practiceSetId) =>
  api.post(
    `/admin/practice_set/${practiceSetId}/generate_random`
  );

// ----------------------------------------------------
// STUDENT APIs
// ----------------------------------------------------
//export const fetchPracticeSetsForStudent = () =>
//  api.get(`/student/exams`);

//export const startPracticeAttempt = (examId) =>
//  api.post(`/student/exam/${examId}/start`);

//export const autoSaveAnswer = (examId, payload) =>
//  api.post(`/student/exam/${examId}/answer`, payload);

//export const submitPracticeAnswers = (examId) =>
//  api.post(`/student/exam/${examId}/submit`);

//##################
// ----------------------------------------------------
// STUDENT QUIZ APIs (ExamAttempt System)
// ----------------------------------------------------

export const fetchStudentPracticeSets = () =>
  api.get(`/quiz/student/practice_sets`);

export const startQuiz = (setId) =>
  api.get(`/quiz/student/start_quiz/${setId}`);

export const saveQuizAnswers = (attemptId, payload) =>
  api.post(`/quiz/student/save_quiz/${attemptId}`, payload);

export const submitQuiz = (attemptId) =>
  api.post(`/quiz/student/submit_quiz/${attemptId}`);

export const fetchQuizResult = (attemptId) =>
  api.get(`/quiz/student/practice/result/${attemptId}`);

// ----------------------------------------------------
// CLASSES & SUBJECTS APIs
// ----------------------------------------------------
export const fetchClasses = () =>
  api.get(`/admin/classes`);

export const fetchSubjects = () =>
  api.get(`/admin/subjects`);

// ----------------------------------------------------
// SUPPORT APIs
// ----------------------------------------------------

// STUDENT: Create Ticket
export const createSupportTicket = (payload) =>
  api.post("/support/student/ticket", payload);

// STUDENT: My Tickets
export const fetchMySupportTickets = () =>
  api.get("/support/student/my-tickets");

// ADMIN: All Tickets
export const fetchAllSupportTickets = () =>
  api.get("/support/admin/tickets");

// ADMIN: Single Ticket
export const fetchSupportTicketById = (id) =>
  api.get(`/support/admin/ticket/${id}`);

// ADMIN: Reply to Ticket
export const replySupportTicket = (id, payload) =>
  api.post(`/support/admin/ticket/${id}/reply`, payload);

// ADMIN: Close Ticket
export const closeSupportTicket = (id) =>
  api.post(`/support/admin/ticket/${id}/close`);

export default api;

